<ng-container [ngSwitch]="layout">
    <ng-container *ngSwitchCase="STORYCARD">
        <ng-container *ngTemplateOutlet="storycard"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="standard"></ng-container>
    </ng-container>
</ng-container>

<ng-template #standard>
    <div *ngIf="data" class="descriptive-wrapper">
        <header class="descriptive-header" *ngIf="data.header">
            <finder-component-header
                [data]="data.header"
                [hrDecoration]="data.hrDecoration"
            ></finder-component-header>
        </header>
        <div class="descriptive-text-wrapper">
            <div class="descriptive-text images-{{position}} {{data.style}}" [ngClass]="{'media-gallery': useMediaGallery}">
                <div class="media-gallery" *ngIf="useMediaGallery">
                    <finder-media-gallery [config]="mediaEngineConfig.config"></finder-media-gallery>
                </div>
                <div class="images" *ngIf="data?.media?.length && !useMediaGallery">
                    <finder-picture *ngFor="let image of data?.media"
                        [picture]="image"
                        [lazyLoad]="imgPreload ? false : true"
                        [loadingType]="imgPreload ? 'eager' : 'lazy'"
                    >
                    </finder-picture>
                </div>
                <finder-dynamic-polyline
                    *ngIf="polyline"
                    [color]="polyline.color"
                    [transition]="polyline.transition"
                    [starting]="polyline.starting"
                    [width]="polyline.width"
                >
                </finder-dynamic-polyline>
                <div class="text">
                    <!-- Support for two lotties around the generic text component -->
                    @defer {
                        <finder-lottie class="lottie-left" *ngIf="data.lotties?.leftLottie"
                            [data]="data.lotties.leftLottie">
                        </finder-lottie>
                    }
                    <finder-generic-text
                        [finderBorderImage]="data?.borderImage"
                        [data]="data.genericText">
                    </finder-generic-text>
                    <finder-button
                        *ngIf="button"
                        [href]="button.link"
                        [target]="button.target"
                        [theme]="button.theme"
                    >{{button.label}}</finder-button>
                    <finder-info-modal *ngIf="data.modal" class="info-modal"
                        [data]="data.modal">
                    </finder-info-modal>
                    @defer {
                        <finder-lottie class="lottie-right" *ngIf="data.lotties?.rightLottie"
                            [data]="data.lotties.rightLottie">
                        </finder-lottie>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #storycard>
    <div class="story-card">
        <finder-component-header
            *ngIf="headerData"
            [data]="headerData"
        ></finder-component-header>
        <finder-storycard
            class="inline"
            [data]="storyCardData"
        ></finder-storycard>
    </div>
</ng-template>
